module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('product-status', {
    attrs: {
      "module": _vm.module
    },
    on: {
      "change": _vm.onChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d9a02de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/reprocessProduct/filters/marketplace/Skyhub.vue
// module id = 2959
// module chunks = 0